<template>
  <div class="row">
    <div class="col-sm-12">
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="form-group col-sm-12 col-md-12 required">
            <label for="account_id">Account:</label>
            <Select2 name="account_id" v-model.number="account_id" :options="accountOptions"/>
          </div>          
          <div class="form-group col-sm-12">
            <input class="btn btn-primary" required type="submit" value="Show" :disabled="this.onRequest">
          </div>
        </div>
      </form>
    </div>
    <div class="col-sm-12">
      <Datatable v-bind:entries="gps_cameras" :columns="columns" :title="'Sim Cards'"/>
    </div>
    <div v-if="this.onRequest" class="modal-backdrop fade show" style="display:flex; align-items: center; justify-content: center;">
      <img :src="require('../assets/loading.gif')"/>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { getCapability } from '../_helpers'
  import Datatable from '../components/Datatable.vue'
  import Select2 from 'vue3-select2-component';
  export default {
    computed: {
      ...mapState('gps_cameras', ['gps_cameras', 'onRequest']),
      ...mapState('accounts', ['accounts']),
      ...mapState('users', ['user']),
      columns(){
        return [
          {name: 'camera_name', text: 'Camera Name'},
          {name: 'gps', text: 'GPS',
            raw: {
              type: 'Sub',
              value: 'serial_number'
            }
          },
          {name: 'ftp_username', text: 'FTP Username'},
          {name: 'ftp_password', text: 'FTP Password'},
          {name: 'show_widget', text: 'Show Widget',
            raw: {
              type: 'Text',
              fields: [
                {value: '1', text: 'True'},
                {value: '2', text: 'False'},
              ]
            }
          },
          {name: 'action', text: 'Action',
            raw: {
              type: 'Action',
              fields: [
                getCapability('edit_gps_camera', this.user) ? {event: 'edit_gps_camera', text: 'Edit', method: 'get', class: 'btn btn-primary'} : {},
                getCapability('delete_gps_camera', this.user) ? {event: 'gps_cameras/destroy', text: 'Delete', method: 'post', class: 'btn btn-danger ml-1'} : {},
              ]
            }
          },
        ]
      }
    },
    data(){
      return {
        account_id: null,
        accountOptions: [],
      }
    },
    components:{
      Datatable,
      Select2,
    },
    methods: {
      ...mapActions('gps_cameras', ['get_gps_camera_by_account']),
      ...mapActions('accounts', ['get_all']),
      ...mapActions('alert', ['error', 'clear']),
      handleSubmit(){
        if(this.onRequest) return;
        this.clear()
        this.get_gps_camera_by_account({account_id: this.account_id})
      },
    },
    created() {
      this.$emit('onChildInit', 'GPS Cameras', getCapability('add_gps_camera', this.user) ? '/gps_cameras/add' : '')
      this.get_all()
    },
    watch: {
      accounts(nextState, prevState){
        if(nextState !== prevState){
          this.accountOptions = []
          if(nextState.length > 0){
            nextState.map(item => {
              this.accountOptions.push({id:item.id, text:item.account_name})
            })
            if(this.accountOptions.length > 0){
              this.account_id = this.accountOptions[0].id
              this.handleSubmit()
            }
          }
          return
        }
      },
    }
  }
</script>
